import { useState } from 'react';
import ManageShell, { type ManageMenuGroup } from '../manage-common/ManageShell';
import ManageRollDashboard from './dashboard/ManageRollDashboard';
import ManageMembers from './members/ManageMembers';
import ManageAttendance from './attendance/ManageAttendance';
import ManageVisitation from './visitation/ManageVisitation';

// 교적관리(/manage-roll): 교적·출석·심방. 교적부 RN앱(com.*churchroll)의 웹 버전.
type MenuKey = 'dashboard' | 'members' | 'attendance' | 'visitation';

const MENU_GROUPS: ManageMenuGroup<MenuKey>[] = [
  {
    group: '홈',
    items: [{ key: 'dashboard', label: '대시보드', icon: '🏠' }],
  },
  {
    group: '교우 관리',
    items: [
      { key: 'members', label: '교적관리', icon: '👥' },
      { key: 'attendance', label: '출석부', icon: '✅' },
      { key: 'visitation', label: '심방관리', icon: '🏠' },
    ],
  },
];

export default function ManageRoll() {
  const [activeMenu, setActiveMenu] = useState<MenuKey>('dashboard');

  return (
    <ManageShell<MenuKey>
      console="roll"
      menuGroups={MENU_GROUPS}
      activeMenu={activeMenu}
      onSelectMenu={setActiveMenu}
    >
      {(session) => (
        <>
          {activeMenu === 'dashboard' && <ManageRollDashboard authChurch={session.authChurch} />}
          {activeMenu === 'members' && <ManageMembers authChurch={session.authChurch} />}
          {activeMenu === 'attendance' && <ManageAttendance authChurch={session.authChurch} />}
          {activeMenu === 'visitation' && <ManageVisitation authChurch={session.authChurch} />}
        </>
      )}
    </ManageShell>
  );
}
